export class PaymentSummary {
  subTotal: number;
  tax: number;
  freightCost: number;
  totalWeight: number;
  grandTotal: number;
  isFreight: boolean;
  shouldRefreshCarriers: boolean;
  currencySign: string;
  weightUnit: string;
  carrierMessage: string;
  quoteId: string;
  selectedCarrierCode: string;
  taxRate: number;
}
